import { useState, useEffect } from 'react';

export const screenBreakpoints = {
  sm: `${768 / 16}em`,
  md: `${1024 / 16}em`,
  lg: `${1200 / 16}em`,
};

const useMedia = query => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) setMatches(media.matches);
    const listener = () => setMatches(media.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
};

export default useMedia;
